var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgExcel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.915 5.989h-3.152V7.61h3.152V5.989ZM19.915 8.553h-3.152v1.622h3.152V8.553ZM19.915 11.121h-3.152v1.622h3.152v-1.622ZM19.915 13.69h-3.152v1.621h3.152V13.69ZM19.915 16.254h-3.152v1.622h3.152v-1.622Z",
  fill: "#D80073"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.273 3.885h-7.329l.007-1.791L12.402 2 2 3.861v16.281L12.498 22l1.395-.031.007-1.92h7.377c.4 0 .723-.333.723-.738V4.627a.731.731 0 0 0-.723-.738l-.004-.004ZM8.81 15.717l-1.124-2.572-1.29 2.416H4.982l1.827-3.66L5.162 8.28h1.47l1.077 2.388 1.11-2.485 1.519-.045-1.79 3.725 1.85 3.847H8.807l.003.007Zm12.604 3.594a.141.141 0 0 1-.14.142h-7.376v-1.574h1.885v-1.622h-1.875v-.946h1.875V13.69h-1.868v-.947h1.868v-1.622h-1.858v-.946h1.858V8.553H13.93v-.946h1.85V5.985h-1.844v-1.5h7.336c.075 0 .14.062.14.142V19.31Z",
  fill: "#D80073"
})));

export default SvgExcel;